import { stickMenuBar, scrollToTop } from "../../../common/functions/others";

import initializeGeneratedArticleSummary from "../../../common/functions/initializeGeneratedArticleSummary";

// NOTE: jQuery 3.x では $('selector').ready() がセレクタを無視して全ページで発火するため、
// $(function(){}) + 明示的なページガードに変更する
$(() => {
  if (!$("body.articles.show").length) return;
  // sidebarの固定など
  $(".jsSticky").stick_in_parent({ parent: "#jsStickyParent", offset_top: 50 });

  stickMenuBar(".jsMain");
  scrollToTop(-50);

  $(".jsTooltipHover").hover(
    function () {
      const text = $(this).data("text");
      $(this).append(`<div class="p_tooltip jsTooltip"><p>${text}</p></div>`);
    },
    function () {
      $(this).find(".jsTooltip").remove();
    }
  );

  $(".jsModalAppear").click(function (event) {
    event.preventDefault();
    $(this).modal({
      modalClass: "mapModal",
    });
  });

  // 募集要約セクションの初期化
  initializeGeneratedArticleSummary();
});
